import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export const ImageLoad = ({ image }) => (
  <LazyLoadImage alt="" src={ image } effect="blur" />
);